import axios from "axios";

const API_BASE_URL = "/api/parties";

/**
 * Party API Service
 * Handles all HTTP requests related to party operations
 */
class PartyService {
  /**
   * Create a new party
   */
  async createParty(partyData) {
    try {
      const response = await axios.post(API_BASE_URL, partyData, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get all parties with pagination and filters
   */
  async getAllParties(params = {}) {
    try {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.search) queryParams.append("search", params.search);
      if (params.isActive !== undefined)
        queryParams.append("isActive", params.isActive);
      if (params.sort) queryParams.append("sort", params.sort);

      const response = await axios.get(
        `${API_BASE_URL}?${queryParams.toString()}`
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get single party by ID
   */
  async getPartyById(partyId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${partyId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Update party
   */
  async updateParty(partyId, partyData) {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/${partyId}`,
        partyData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Delete party
   */
  async deleteParty(partyId) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${partyId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get all active parties (for dropdowns)
   */
  async getActiveParties() {
    try {
      const response = await axios.get(`${API_BASE_URL}/active/list`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * GST lookup: get PAN and optionally legal/trade name from GSTIN
   */
  async getGstLookup(gstin) {
    try {
      const response = await axios.get(`${API_BASE_URL}/gst-lookup`, {
        params: { gstin: (gstin || "").trim().toUpperCase() },
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Handle API errors
   */
  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data?.message || "An error occurred",
        status: error.response.status,
        data: error.response.data,
      };
    } else if (error.request) {
      return {
        message: "Network error. Please check your connection.",
        status: 0,
      };
    } else {
      return {
        message: error.message || "An unexpected error occurred",
        status: 0,
      };
    }
  }
}

const partyService = new PartyService();
export default partyService;

